<div class="row border Page-Header">
  <div class="col-12">
    <h6 class="HeadContent">
      Admin : Course Management : Mock Exam : Add/Remove Questions
    </h6>
  </div>
</div>
<app-change-course-header
  [heading]="''"
  [showChangeCourse]="false"
></app-change-course-header>

<div class="mt-2">
  <div
    class="d-flex justify-content-between align-items-center border-bottom pb-2"
  >
    <!-- Subject and Question Count -->
    <div>
      <span class="fw-bold" style="color: #0c4788">{{ subjectName }}</span> :
      <span
        class="fw-bold"
        [ngClass]="
          +currentNumberOfQuestions < +totalQuestions
            ? 'text-danger'
            : 'text-dark'
        "
      >
        {{ currentNumberOfQuestions }}
      </span>

      /
      <span class="fw-bold text-dark">{{ totalQuestions }}</span>
      <button
        class="btn btn-primary ms-5 bl-btn border text-nowrap"
        (click)="getQuestionsForMockExam()"
      >
        Reload Questions
      </button>
    </div>

    <!-- Save and Clear Buttons -->
    <div class="d-flex">
      <button
        class="btn btn-primary me-2 bl-btn border text-nowrap"
        (click)="onSave()"
      >
        Save
      </button>
      <button class="btn btn-light border text-nowrap" (click)="navigateBack()">
        Cancel
      </button>
    </div>
  </div>

  <!-- Question Rows -->
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead class="table-light">
        <tr>
          <th class="text-center" style="width: 3%"></th>
          <th style="width: 30%; vertical-align: middle" class="text-center">
            Topic
          </th>
          <th style="width: 5%; vertical-align: middle" class="text-center">
            Question Id
          </th>
          <th style="width: 15%; vertical-align: middle" class="text-center">
            Question
          </th>
          <th style="width: 30%; vertical-align: middle" class="text-center">
            Answer Choices
          </th>
          <th style="width: 5%; vertical-align: middle" class="text-center">
            Right Answer Score
          </th>
          <th style="width: 5%; vertical-align: middle" class="text-center">
            Wrong Answer Score
          </th>
          <th style="width: 5%; vertical-align: middle" class="text-center">
            Answering Time
          </th>
          <!-- <th style="width: 3%; vertical-align: middle">Optional Question</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of questions">
          <td class="text-center">
            <input
            type="checkbox"
            class="form-check-input custom-checkbox"
            [disabled]="!!questionId || currentNumberOfQuestions >= totalQuestions && !item.SelectedQuestion"
            [(ngModel)]="item.SelectedQuestion"
            (change)="onQuestionSelectionChange(item,$event)"
          />

          </td>
          <td style="text-align:left">{{ item.Path_Name }}</td>
          <td><span [innerHTML]="item.Question_ID"></span></td>
          <td><span style="text-align:left" [innerHTML]="item.Question_Text"></span></td>
          <td>
            <ul class="list-unstyled">
              <li
                *ngFor="let choice of item.Answer_Choices"
                class="d-flex align-baseline"
              >
                <ng-container *ngIf="choice.Answer_Choice_Text">
                  <input
                    *ngIf="choice.Right_Answer_Ind === 'N'"
                    type="checkbox"
                    class="form-check-input me-2"
                    (change)="onAnswerSelectionChange(item, choice, $event)"
                    [disabled]="
                      (!item.SelectedQuestion || choice.Right_Answer_Ind === 'Y')&& !item.SelectedQuestion
                    "
                    [(ngModel)]="choice.selected"
                  />
                  <div class="d-flex align-baseline gap-1">
                    <input
                      *ngIf="choice.Right_Answer_Ind === 'Y'"
                      type="checkbox"
                      class="form-check-input me-2 hello"
                      [checked]="true"
                      [disabled]="choice.Right_Answer_Ind === 'Y'"
                      [(ngModel)]="choice.selected"
                    />
                    <strong *ngIf="choice.Right_Answer_Ind === 'Y'">[R]</strong>
                  </div>
                  <span
                    class="ms-1"
                    [innerHTML]="choice.Answer_Choice_Text"
                  ></span>
                </ng-container>
              </li>
            </ul>
          </td>

          <td>
            <input
              type="number"
              class="form-control"
              [disabled]="
                !!item.Right_Answer_Default_Score || !item.SelectedQuestion
              "
              [(ngModel)]="item.RightAnswerDefaultScore"
            />
          </td>
          <td>
            <input
              type="number"
              class="form-control"
              [disabled]="
                !!item.Wrong_Answer_Penalty_Default_Score ||
                !item.SelectedQuestion
              "
              [(ngModel)]="item.WrongAnswerPenaltyDefaultScore"
            />
          </td>
          <td>
            <input
              type="number"
              class="form-control"
              [disabled]="
                !!item.Time_To_Answer_In_Seconds || !item.SelectedQuestion
              "
              [(ngModel)]="item.TimeToAnswerInSeconds"
            />
          </td>
          <!-- <td class="text-center">
            <input
              type="checkbox"
              class="form-check-input"
              [disabled]="
                !item.Total_Number_Of_Optional_Questions ||
                !item.SelectedQuestion
              "
              [(ngModel)]="item.Optional_Question_Ind"
            />
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>
